import { DefaultHiddenSeries } from '@/insights/assets/historyGraph/types'
// per page single source of truth for hidden legend items per page
// replicate this on a per page basis wherever AssetHistoryChart is used and need different default legend items selected by default

export const ALERT_ACK_HIDDEN_SERIES: DefaultHiddenSeries = {
  labels: ['Set Point', 'Return Air', 'Supply Air', 'Ambient'],
  namePattern: /rear/i,
}
